import { useSelector } from 'react-redux';
import { IconProduct3DPlan16, IconMediaPhoto16, IconActionPlan16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { selectImages, selectTour } from '../selectors';
import { EMediaType, IGallerySlide } from '../types/project';
import { IGalleryTab } from '../types/gallery';

interface IParams {
  withTour?: boolean;
}

export const useGalleryData = ({ withTour }: IParams = {}) => {
  const { images, layoutImages } = useSelector(selectImages);
  const tour = useSelector(selectTour);

  const slides: IGallerySlide[] = React.useMemo(() => {
    let slidesList = [];

    const [firstPhoto, ...restPhotos] = images.map(({ full, thumbnail }) => {
      return {
        full,
        img: full,
        thumb: thumbnail,
        type: EMediaType.Photo,
      };
    });

    if (firstPhoto) {
      slidesList.push(firstPhoto);
    }

    const layouts = layoutImages.map(({ full, thumbnail }) => {
      return {
        full,
        img: full,
        thumb: thumbnail,
        type: EMediaType.Layout,
      };
    });
    slidesList = slidesList.concat(layouts);

    if (withTour && tour) {
      slidesList.push({
        ...(firstPhoto || {}),
        type: EMediaType.Tour,
      });
    }

    slidesList = slidesList.concat(restPhotos);

    return slidesList;
  }, [images, layoutImages, tour, withTour]);

  const tabs: IGalleryTab[] = React.useMemo(() => {
    const tabsList = [];

    if (layoutImages.length) {
      tabsList.push({
        type: EMediaType.Layout,
        icon: <IconActionPlan16 color="icon-on-bright-default" />,
        title: 'Планировка',
      });
    }

    if (tour) {
      tabsList.push({
        type: EMediaType.Tour,
        icon: <IconProduct3DPlan16 color="icon-on-bright-default" />,
        title: '3D–тур по дому',
      });
    }

    if (images.length) {
      tabsList.push({
        type: EMediaType.Photo,
        icon: <IconMediaPhoto16 color="icon-on-bright-default" />,
        title: `${images.length} фото`,
      });
    }

    return tabsList;
  }, [tour, images, layoutImages]);

  return { slides, tabs };
};
